module.exports = __webpack_public_path__ + "static/media/hearts_10.9b3f646b.png";